import { useLocation } from "react-router-dom";

const generateUrlWithParams = (params) => {
  const urlParams = new URLSearchParams(params);
  return `?${urlParams.toString()}`;
};
const urlWithParams = (location) => {
  const params = location.search;
  return params ? params : null;
};
const queryObject = (location) => {
  const params = new URLSearchParams(location.search);
  // Convert URLSearchParams to an object

  const hasData = (obj) => {
    return obj && Object.keys(obj).length > 0;
  };
  // ใช้งาน
  if (hasData(Object.fromEntries(params.entries()))) {
    // queryObject มีข้อมูล
    return Object.fromEntries(params.entries());
  } else {
    // queryObject ไม่มีข้อมูล
    return null;
  }
};

const urlParams = { generateUrlWithParams, queryObject, urlWithParams };
export default urlParams;
